import { render } from "./HomeVolleyball.vue?vue&type=template&id=3584942b&ts=true"
import script from "./HomeVolleyball.vue?vue&type=script&lang=ts"
export * from "./HomeVolleyball.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__